"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("@components/Modal/index"));
var Button_1 = __importStar(require("@components/Button"));
var react_i18next_1 = require("react-i18next");
var BlangEditor_1 = require("@/react-app/common/components/BlangEditor");
var regexValidator_1 = require("@/react-app/common/services/regexValidator");
function ImportDictionaryItemModal(props) {
    var onConfirm = props.onConfirm, isOpen = props.isOpen, setIsOpen = props.setIsOpen;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = __read(react_1.default.useState(false), 2), listHasError = _a[0], setListHasError = _a[1];
    var _b = __read(react_1.default.useState([]), 2), errorLines = _b[0], setErrorLines = _b[1];
    var _c = __read(react_1.default.useState(), 2), codeMirrorValue = _c[0], setCodeMirrorValue = _c[1];
    var onCodeMirrorChange = react_1.default.useCallback(function (value) {
        setCodeMirrorValue(value);
    }, []);
    var invalidTextTranslation = errorLines.length === 1
        ? t('AUTOMATION.LISTS.ERROR.REGULAR_EXPR_INVALID_TEXT_REACT')
        : t('AUTOMATION.LISTS.ERROR.REGULAR_EXPR_INVALID_TEXT_REACT_PLURAL');
    var handleImportKeywords = function () {
        if (!codeMirrorValue) {
            setIsOpen(false);
            return;
        }
        setListHasError(false);
        setErrorLines([]);
        var newErrorLines = [];
        var importedItems = [];
        var lines = codeMirrorValue.split('\n');
        lines.forEach(function (line, index) {
            var text = line.trim();
            if ((0, regexValidator_1.isRegExp)(text) && !(0, regexValidator_1.isValidRegExp)(text)) {
                newErrorLines.push(index + 1);
            }
            else if (text) {
                importedItems.push(text);
            }
        });
        if (newErrorLines.length > 0) {
            setErrorLines(newErrorLines);
            setListHasError(true);
            return;
        }
        onConfirm(importedItems);
        setCodeMirrorValue('');
        setIsOpen(false);
    };
    return (react_1.default.createElement(index_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, modalContentClassName: "modalContent" },
        react_1.default.createElement("div", { className: "delete-item-modal" },
            react_1.default.createElement("div", { className: "modal-header" },
                react_1.default.createElement("h3", null, t('AUTOMATION.LISTS.LIST_BUILDER.KEYWORD_IMPORTER.TITLE')),
                react_1.default.createElement("br", null),
                react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: t('AUTOMATION.LISTS.LIST_BUILDER.KEYWORD_IMPORTER.TEXT') } })),
            react_1.default.createElement("div", { className: "modal-body" },
                react_1.default.createElement("div", { className: "code-mirror-highlight-regex-mode" },
                    react_1.default.createElement(BlangEditor_1.BlangEditor, { editable: true, value: codeMirrorValue, onChange: onCodeMirrorChange, width: "638px", height: "300px", disableHighlight: true })),
                listHasError && (react_1.default.createElement("div", { className: "notification-error" },
                    react_1.default.createElement("div", { className: "notification-title" }, t('AUTOMATION.LISTS.ERROR.REGULAR_EXPR_INVALID_TITLE')),
                    react_1.default.createElement("div", { className: "notification-text" },
                        react_1.default.createElement("span", null, invalidTextTranslation),
                        errorLines.map(function (line, index) { return (react_1.default.createElement("span", { key: index },
                            line,
                            " ",
                            index !== errorLines.length - 1 ? ', ' : '')); })),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: t('AUTOMATION.LISTS.ERROR.REMOVE_INVALID_LINE_TEXT') } })))),
            react_1.default.createElement("div", { className: "delete-modal__button-group" },
                react_1.default.createElement(Button_1.SecondaryButton, { text: t('AUTOMATION.LISTS.BTN.CLOSE'), onClick: function () { return setIsOpen(false); } }),
                react_1.default.createElement(Button_1.default, { text: t('AUTOMATION.LISTS.BTN.IMPORT_KEYWORDS'), onClick: handleImportKeywords })))));
}
exports.default = ImportDictionaryItemModal;
